module.exports = __webpack_public_path__ + "static/fonds-img-cd4855b7009c51236fb433e6e864e8ac.svg";